import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { Quote, StockLines } from "../../../../models/quote.model";
import { QuoteService } from "../../../../services/quote.service";
import { Sort } from '@angular/material/sort';
import { Subscription } from "rxjs";
import { CheckOutService } from "../../../../services/checkout.service";
import { map, switchMap } from "rxjs/operators";
import { ManageService } from "../../../../services/manage.service";
import { ApiResponse } from "../../../../models/api-response.model";
import { CheckoutStatusModel, CheckoutViewModel } from "../../../../models/check-out.model";
import { AuthService } from "../../../../services/auth.service";
import { CurrentUserModel } from "../../../../models/account-ledger.model";
import { first } from "rxjs/operator/first";

export interface QuoteOrderItem {
    stockCode: string
    description: string
    qty: number
    price: number
    retailPrice: number
}

@Component({
    selector: 'app-price-list-summary',
    templateUrl: './price-list-summary.component.html',
    styleUrls: ['./price-list-summary.component.css']
})
export class PriceListSummaryComponent implements OnInit, OnDestroy {

    title: string = 'Price List Summary';

    loadContent: boolean = true;

    stocklinesSubscription: Subscription;

    routeSubscription: Subscription;

    currentUser$: Subscription;

    currentUserModel: CurrentUserModel;

    filterInput: string;

    quoteId: string;

    version: string;

    expiry: string;

    stocklines: StockLines[] = [];

    sortedData: StockLines[] = [];
    total: number = 0;
    checkoutStatus: CheckoutStatusModel = {
        currentStep: '',
        firstStep: '',
        hasChosenCheckout: false,
        collectOrder: false,
        tenantDetailsRequired: ''
    };

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private quoteService: QuoteService,
        private manageService: ManageService,
        private checkoutService: CheckOutService,
        private authService: AuthService) {
        this.title = 'Price List Summary'
    }

    ngOnInit() {

        $('#levelOne').animate(
            { scrollLeft: (500 + $('#price-list-detail').width()) },
            {
                duration: 100,
                complete: function () {
                    //console.log('animation stops');
                    $('#levelOne').stop(true, false);
                }
            });

        this.stocklinesSubscription = this.quoteService.stocklines$
            .subscribe((data) => {
                this.stocklines = data;
                this.sortedData = this.stocklines.slice();
                this.getTotal();
            });

        this.routeSubscription = this.route.parent.paramMap.pipe(
            switchMap((params: ParamMap) => {
                return this.route.paramMap.pipe(
                    map((param: ParamMap) => {
                        return {
                            quoteId: params.get('sku'),
                            version: params.get('version'),
                            expiry: param.get('expiry')
                        }
                    })
                )
            })
        ).subscribe((data) => {
            this.quoteId = data.quoteId;
            this.version = data.version;
            this.expiry = data.expiry;
        })

        this.currentUser$ = this.authService.getLoginInfo().subscribe((user: CurrentUserModel) => {
            this.currentUserModel = user;
        })


    }

    close() {
        this.router.navigate(['../../'], { relativeTo: this.route })
        $('#levelOne').animate(
            { scrollLeft: (250) })
    }

    sortData(sort: Sort) {
        const data = this.stocklines.slice();
        if (!sort.active || sort.direction === '') {
            this.sortedData = data;
            return;
        }
        this.sortedData = data.sort((a, b) => {
            const isAsc = sort.direction === 'asc';
            switch (sort.active) {
                case 'stockDesc': return compare(a.stockDesc.toLowerCase(), b.stockDesc.toLowerCase(), isAsc);
                case 'stockOnHand': return compare(parseInt(a.stockOnHand), parseInt(b.stockOnHand), isAsc);
                case 'price': return compare(parseInt(a.price), parseInt(b.price), isAsc);
                case 'quantity': return compare(parseInt(a.quantity), parseInt(b.quantity), isAsc);
                case 'lineTotal': return compare(parseInt(a.lineTotal), parseInt(b.lineTotal), isAsc);
                default: return 0;
            }
        });
    }

    getTotal() {
        this.total = 0;
        this.sortedData.forEach((v, i) => {
            this.total += Number(v.quantity) * Number(v.price);
        })
    }


    checkOut() {
        //checkout quotes
        this.loadContent = false;
        let items: QuoteOrderItem[] = [];

        this.sortedData.forEach((value) => {
            let item = {} as QuoteOrderItem;
            item.stockCode = value.stockCode;
            item.description = value.stockDesc;
            item.qty = Number(value.quantity);
            item.price = Number(value.price);
            item.retailPrice = Number(value.retailPrice);
            items.push(item);
        })

        this.manageService.quoteOrders(this.quoteId, this.version, this.expiry, items).subscribe((res: ApiResponse) => {
            const [cartid, cartName] = res.responseMessage.split('/');
            this.checkoutService.CartCheckout(Number(cartid)).subscribe((res: CheckoutViewModel) => {

                this.checkoutService.monitorCurrentCheckoutViewModel(res);

                this.checkoutStatus.hasChosenCheckout = true;
                this.checkoutStatus.firstStep = res.firstStep;
                this.checkoutStatus.currentStep = res.firstStep;
                this.loadContent = true;

                this.checkoutService.monitorCurrerntCheckoutStatusModel(this.checkoutStatus);

                this.loadContent = true;

                let firstStep: string;

                switch (res.firstStep) {
                    case 'TENANT':
                        firstStep = 'tenant';
                        break;
                    case 'ADDRESS':
                        firstStep = 'ship-address';
                        break;
                    case 'ENDUSER':
                        firstStep = 'end-user';
                        break;
                    case 'PAYMENT':
                        if (this.currentUserModel.isAU) {
                            firstStep = 'donation';
                        } else {
                            firstStep = 'payment-method';
                        }
                        break;
                    case 'NOENDUSER':
                        firstStep = 'ship-address';
                        break;
                }

                this.router.navigate([`checkout/${cartid}/${cartName}/${firstStep}`], { relativeTo: this.route })
            })

        },
            (error) => {
                this.loadContent = true;
            })

    }

    onLoading(currentLoadingStatus: boolean) {
        this.loadContent = !currentLoadingStatus;
    }

    ngOnDestroy() {
        this.stocklinesSubscription.unsubscribe();
        this.routeSubscription.unsubscribe();
        this.currentUser$.unsubscribe();
    }
}

function compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
